var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Solicitacao',{attrs:{"filtro":this.filtro,"nova":true},on:{"clear":function($event){return _vm.clearFilter()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }